enum MarkLocation {
    TOP = 'top',
    BOTTOM = 'bottom',
}
enum MarkType {
    LINE = 'line',
    TRIANGLE = 'triangle',
}
enum MarkAnchor {
    START = 'start',
    MIDDLE = 'middle',
    END = 'end',
}
interface IMarketItem {
    position: number;
    textColor?: string;
    isTextColorFollowColor?: boolean; // 文字颜色跟随标记颜色
    color?: string;
    textAnchor?: MarkAnchor; // 文字锚点
    strokeWidth?: number; // 线宽
    location?: MarkLocation; // 默认在下方
    type?: MarkType;
    label?: string;
    fontSize?: number;
}
interface IMarketOption extends React.SVGProps<SVGTextElement> {
    progress: number;
}
// progress

interface IProps {
    width?: number;
    className?: string;
    offsetWidth?: number;
    offsetHeight?: number;
    height?: number;
    color?: string;
    backgroundColor?: string;
    progress?: number;
    suffixText?: string;
    markers?: IMarketItem[];
    suffixTextConfig?: {
        fontSize: number;
        x: number;
    };
}
export { IProps, MarkAnchor, MarkLocation, MarkType, IMarketItem, IMarketOption };
